import { Component, OnInit, OnDestroy } from '@angular/core';
import { ClosableModalWithErrorResponseModel } from 'src/app/shared/components/base/closable-modal-with-error-response-model';
import { EntityValidationErrorResponse } from 'src/app/shared/models';
import { NotificationService } from 'src/app/shared/services';
import { ModalService } from 'src/app/shared/modules/modal';

@Component({
  selector: 'planning-new-scenario-modal',
  templateUrl: './planning-new-scenario-modal.component.html',
  styleUrls: ['./planning-new-scenario-modal.component.css']
})
export class PlanningNewScenarioModalComponent extends
  ClosableModalWithErrorResponseModel<EntityValidationErrorResponse>
  implements OnInit, OnDestroy {

  constructor(
    protected notificationService: NotificationService,
    protected modalService: ModalService,
  ) {
    super(notificationService, modalService);
  }

  scenarioName: string;

  ngOnInit() {
  }

  exitModal(): void {
    this.closeAllModals();
  }

  submitName() {
    this.success(this.scenarioName);
  }

}
